import { Button } from "@/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { ArrowUp, Heart } from "lucide-react";
import { socialLinks, ICONES_SOCIALES } from "@/lib/social-config";

export const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="relative py-16">
      
      <div className="container mx-auto px-4 sm:px-6 relative">
        <div data-reveal className="flex flex-col items-center space-y-6 text-center sm:space-y-8">
          {/* Logo & Description */}
          <div className="space-y-3 sm:space-y-4 ">
            <div className="flex items-center justify-center space-x-2">
              <div className="w-2 h-2 bg-primary rounded-full animate-glow"></div>
              <span className="font-bold text-sm sm:text-lg lg:text-xl">Tokam Darius</span>
            </div>
            <p className="text-sm sm:text-base text-muted-foreground max-w-md">
              Développeur web à Jonquière. Applications web sur mesure, de la
              conception jusqu'à la mise en production.
            </p>
          </div>

          {/* Quick Links */}
          <div className="flex flex-wrap justify-center gap-4 sm:gap-8">
            <a 
              href="/"
              className="text-sm sm:text-base text-muted-foreground hover:text-primary transition-colors duration-300"
            >
              Accueil
            </a>
            <a 
              href="/a-propos"
              className="text-sm sm:text-base text-muted-foreground hover:text-primary transition-colors duration-300"
            >
              À propos
            </a>
            <a 
              href="/projets" 
              className="text-sm sm:text-base text-muted-foreground hover:text-primary transition-colors duration-300"
            >
              Projets
            </a>
            <a 
              href="/contact"
              className="text-sm sm:text-base text-muted-foreground hover:text-primary transition-colors duration-300"
            >
              Contact
            </a>
          </div>

          {/* Social Links */}
          <div className="flex space-x-4">
            {Object.entries(socialLinks).map(([key, social]) => {
              const IconComponent = ICONES_SOCIALES[social.icon as keyof typeof ICONES_SOCIALES];
              
              return (
                <Tooltip key={key}>
                  <TooltipTrigger asChild>
                    <Button 
                      variant="outline" 
                      size="icon" 
                      className={`hover:bg-primary/10 hover:border-primary hover:text-primary transition-colors duration-200 ${!social.available ? 'opacity-50 cursor-not-allowed' : ''}`}
                      asChild={social.available}
                      disabled={!social.available}
                    >
                      {social.available ? (
                        <a href={social.url} target="_blank" rel="noopener noreferrer">
                          <IconComponent className="h-4 w-4" />
                        </a>
                      ) : (
                        <span>
                          <IconComponent className="h-4 w-4" />
                        </span>
                      )}
                    </Button>
                  </TooltipTrigger>
                  <TooltipContent>
                    <p>{social.label}</p>
                  </TooltipContent>
                </Tooltip>
              );
            })}
          </div>

          {/* Divider */}
          <div className="w-full max-w-md h-px bg-gradient-to-r from-transparent via-border to-transparent opacity-50"></div>

          {/* Copyright & Back to top */}
          <div className="flex flex-col sm:flex-row items-center justify-between w-full gap-3 sm:gap-4 text-xs sm:text-sm text-muted-foreground">
            <div className="flex flex-col sm:flex-row items-center sm:space-x-1 text-center sm:text-left">
              <span>© {new Date().getFullYear()} Tokam Darius.</span>
              <span>Construit avec React</span>
            </div>
            
            <Button
              variant="ghost"
              size="sm"
              onClick={scrollToTop}
              className="group text-muted-foreground hover:text-primary transition-all duration-300 text-xs sm:text-sm"
            >
              <ArrowUp className="h-3 w-3 sm:h-4 sm:w-4 mr-1 group-hover:-translate-y-1 transition-transform" />
              Retour en haut
            </Button>
          </div>
        </div>
      </div>
    </footer>
  );
};
